import React from 'react';
import { motion } from 'framer-motion';

const FoundationStorySection = () => {
  return (
    <section className="py-24 bg-[#FAF9F6]" data-testid="foundation-story-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image with decorative frame */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            {/* Gold decorative frame */}
            <div className="absolute -top-4 -left-4 w-full h-full border-2 border-amber-400/60 rounded-sm" />
            <div className="absolute -bottom-4 -right-4 w-20 h-20 border-b-2 border-r-2 border-amber-400/60" />
            
            <img
              src="https://images.unsplash.com/photo-1582719508461-905c673771fd?auto=format&fit=crop&w=800&q=80"
              alt="Luxury resort overlooking the ocean"
              className="relative w-full h-auto rounded-sm shadow-lg"
            />
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <p className="text-xs font-bold tracking-[0.25em] uppercase text-amber-700 mb-6">
              Our Foundation
            </p>
            
            <h2 className="text-4xl sm:text-5xl font-medium text-[#0B1120] tracking-tight leading-tight mb-8 font-serif italic">
              Built on Service.{' '}
              <span className="text-[#1E3A8A]">Driven by Purpose.</span>
            </h2>
            
            <div className="space-y-6 text-lg text-slate-600 font-light leading-relaxed">
              <p>
                Prestigious Travel Club Foundation was built from a background rooted in military 
                service and ministry—two paths that instill discipline, compassion, and an 
                unwavering commitment to others.
              </p>
              
              <p>
                These experiences created a core belief that drives everything we do:
              </p>
              
              <p className="text-xl text-[#0B1120] font-medium italic border-l-4 border-amber-400 pl-6">
                Giving is not something we do occasionally—it's who we are.
              </p>
              
              <p>
                This foundation was not built around trends or convenience. It was built around 
                purpose. Every decision, every partnership, and every initiative reflects a 
                commitment to service that was shaped long before this organization existed.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default FoundationStorySection;
